<div bsModal #newsurvey="bs-modal" id="newregular" class="modal fade" (onShown)="onShown()"  role="dialog" aria-labelledby="newssurvey" aria-hidden="true" [config]="{backdrop: 'static'}">
    <div class="modal-dialog">

        <div #modalContent class="modal-content" style="min-height: 400px;">
            <div class="modal-header text-center">
                <button type="button" class="close" (click)="close()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <h2 class="modal-title text-center"><span class="capitalize">{{action}}</span> Survey question</h2>
            </div>

            <ng-container *ngIf="savingQuestion">
                <div class="loading text-center" >
                    <br />
                    <img style="padding-top:50px;" src="../../../assets/img/gif/loading.gif" alt="Alternate Text" />
                    <br />
                    <p>Saving Question, please wait...</p>
                </div>
            </ng-container>

            <div *ngIf="!savingQuestion" class="modal-body">
                <div class="row">
                    <div class="col-4 col-md-3 noPadding">
                        <label>Language:</label>
                    </div>
                    <div class="col-8 col-md-9 noPadding">
                        <select #languageShortCode id="surveyLanguages" (change)="checkData(languageShortCode.value, $event)">
                            <option *ngFor="let language of languages" id="{{language.Name}}" [value]="language.ShortCode">{{language.Name}}</option>
                        </select>
                    </div>
                </div>

                <div class="row">
                    <div class="col-4 col-md-3 noPadding">
                        <label>Text:</label>
                    </div>
                    <div class="col-8 col-md-9 noPadding">
                        <textarea (focusout)="addLocalization(text.value, languageShortCode.value)"
                                  (keypress)="preventSpace(text.value, $event, text.id)"
                                  (keyup)="preventSpace(text.value, $event, text.id)"
                                  id="surveyTextarea" class="" #text placeholder="Question body" cols="2" rows="2">{{text}}</textarea>
                    </div>
                </div>

                <div class="row">
                    <div class="col-4 col-md-3 noPadding">
                        <label>Test Question:</label>
                    </div>
                    <div class="col-8 col-md-9 noPadding">
                        <div class="checkbox" style="display: contents;">
                            <input (change)="changeTestQuestionStatus()" id="surCheckboxTest" type="checkbox" [checked]="testQuestion">
                            <label for="surCheckboxTest"></label>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-4 col-md-3 noPadding">
                        <label>Is Mandatory:</label>
                    </div>
                    <div class="col-8 col-md-9 noPadding">
                        <div class="checkbox" style="display: contents;">
                            <input id="isMandatory" type="checkbox" [(ngModel)]="isMandatory">
                            <label for="isMandatory"></label>
                        </div>
                    </div>
                </div>

                <br />


                <div class="row" *ngIf="!loadingChoices">
                    <div class="container-fluid noPadding">
                        <div class="d-sm-flex align-items-center justify-content-between mb-4 margin-bottom">
                            <h5 *ngIf="!loadingChoices">Choices</h5>
                            <!--<h1 class="h3 mb-0 text-gray-800"></h1>-->
                            <div class="btns-container">
                                <div>
                                    <a (click)="confirmDelete()" class="d-none d-sm-inline-block btn btn-sm shadow-sm margin-right-5" [ngClass]="{'btn-red': canDelete, 'btn-gray': !canDelete}">
                                        <i class="fas fa-trash text-white-50"> <span class="button-text"> Delete</span></i>
                                    </a>
                                    <a (click)="openChoiceModal('new')" class="d-none d-sm-inline-block btn btn-sm shadow-sm btn-primary">
                                        <i class="fas fa-plus text-white-50"> <span class="button-text"> Add choice</span></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <ng-container *ngIf="loadingChoices">
                    <div class="row">
                        <div class="col-12" style="width: 100%; max-height: 400px; height:400px;">
                            <div class="loading text-center">
                                <br />
                                <img style="padding-top:50px;" src="../../../assets/img/gif/loading.gif" alt="Alternate Text" />
                                <br />
                                <p>Loading choices, please wait...</p>
                            </div>
                        </div>
                    </div>
                </ng-container>

                <div class="row" *ngIf="!loadingChoices">
                    <div class="col-12">
                        <div style="width: 100%; max-height: 400px; height:400px;">
                            <ag-grid-angular #surveyChoicesAgGrid
                                             style="width: 100%; height: 100%;"
                                             class="ag-theme-balham"
                                             [enableFilter]="true"
                                             [gridOptions]="gridOptions"
                                             [rowData]="currentLocalizationsChoices"
                                             [columnDefs]="currentLocalizationsChoicesHeaders"
                                             [enableSorting]="true"
                                             [enableColResize]="true"
                                             (rowClicked)="onRowClicked($event)"
                                             (gridReady)="onGridReady($event)"
                                             [pagination]="true"
                                             [paginationPageSize]="25"
                                             [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                             [rowClassRules]="rowClassRules"
                                             [rowSelection]="rowSelection"
                                             (rowSelected)="onRowSelected($event)"
                                             (selectionChanged)="onSelectionChanged($event)"
                                             [rowMultiSelectWithClick]="true"
                                             [suppressRowClickSelection]="true">
                            </ag-grid-angular>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-footer text-right" *ngIf="!savingQuestion" >
                <input (click)="close()" type="button" class="btn" name="close" value="Cancel" />

                <ng-container>
                    <input type="button" (click)="saveQuestion()" class="btn btn-primary waves-effect" value="Save" />
                </ng-container>
            </div>
        </div>
    </div>
</div>

<!-- Modal -->
<div class="modal fade" id="modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header"> 
                <div class="text-center">
                    <h2 class="modal-title text-center" id="ModalLabel">{{choiceAction}} Survey Question Choice</h2>
                </div>
                <button (click)="closeChoiceModal()" type="button" class="close" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-12 col-md-2 noPadding">
                        <label>Language:</label>
                    </div>
                    <div class="col-12 col-md-10 noPadding">
                        <input #newChoiceLanguage class="input_readonly" type="text" id="{{currentOrDefaultLanguageShortCode}}" value="{{currentOrDefaultLanguage}}" readonly/>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-md-2 noPadding">
                        <label>Text:</label>
                    </div>
                    <div class="col-12 col-md-10 noPadding">
                        <textarea #newChoiceText id="createchoiceTextarea" class="" #createchoiceTextarea placeholder="Choice" cols="2" rows="2"></textarea>
                    </div>
                </div>
            </div>


            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="closeChoiceModal()">Cancel</button>
                <ng-container *ngIf="newChoice">
                    <button type="button" class="btn btn-primary" (click)="addNewChoice(newChoiceLanguage.value, newChoiceLanguage.id, newChoiceText.value)">Ok</button>
                </ng-container>

                <ng-container *ngIf="editChoice">
                    <button type="button" class="btn btn-primary" (click)="updateChoice(newChoiceText.value)">Ok</button>
                </ng-container>
            </div>
        </div>
    </div>
</div>
